// src/slices/article/reducer.js
import { createSlice } from "@reduxjs/toolkit";
import { getArticles, getOneArticle } from "./thunk";

const initialState = {
  loading: { all: false, single: false },
  Pagination: {},
  totalCount: 0,

  articles: [],
  article: null,
  error: null
};
const articleSlice = createSlice({
  name: "article",
  initialState,

  reducers: {
    clearArticle: (state) => {
      state.article = null;
    }
  },

  extraReducers: (builder) => {
    builder

      // ================= GET ALL =================
      .addCase(getArticles.pending, (state) => {
        state.loading.all = true;
        state.error = null;
      })

      .addCase(getArticles.fulfilled, (state, action) => {
        state.loading.all = false;


        state.articles = action.payload?.data || [];
        state.Pagination = action.payload?.responseDetails?.pagination || {};
        state.totalCount = action.payload?.responseDetails?.filteredCount ?? (action.payload?.responseDetails?.totalCount || 0);
      })

      .addCase(getArticles.rejected, (state, action) => {
        state.loading.all = false;
        state.error = action.payload;
      })

      // ================= GET ONE =================
      .addCase(getOneArticle.pending, (state) => {
        state.loading.single = true;
        state.error = null;
      })

      .addCase(getOneArticle.fulfilled, (state, action) => {
        state.loading.single = false;

        state.article = action.payload || null;
      })

      .addCase(getOneArticle.rejected, (state, action) => {
        state.loading.single = false;
        state.error = action.payload;
      });
  }
});

export const { clearArticle } = articleSlice.actions;
export default articleSlice.reducer;
